import { Row, Col, Breadcrumb } from "react-bootstrap";
import { ISubmissionDetails } from "../../../api/ISubmission";
import { ILicenceProfile } from "../../../api/ILicenceProfile";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  submissionDetails: ISubmissionDetails;
}

const BreadCrumbs = ({
  licenceProfile,
  submissionDetails,
}: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/licence-profile/${licenceProfile.profileNo}`}>
          {licenceProfile.organisation} - {licenceProfile.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/versions`}
        >
          Authorisation Versions
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/versions/${submissionDetails.licenceid}`}
        >
          {submissionDetails.licence_regno}
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{submissionDetails.casenumber}</Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
